import React, { Suspense, useEffect, useState } from "react";
import {
  HashRouter,
  Route,
  Redirect,
  Switch,
  useHistory,
} from "react-router-dom";
import HeaderMain from "./Components/Layout/HeaderMain";
import Dialog from './Components/Dialog'
import { routes } from "./Routes/Routes";
import { useSelector } from "react-redux";
import AddToHome from "./Components/AddToHome";
import GoToWebPage from "./Components/GoToWebPage";
import Resize from './Utils/Resize'
import { RotatePhone } from "./assets/icons";

const App = () => {
  const history = useHistory();
  const isLogin = useSelector((state) => state.auth.isLogin);
  const [resizeDlg, setResizeDlg] = useState(false)
  const resize = Resize();


  useEffect(() => {
    if (resize == undefined || resize == 0) {
      setResizeDlg(false)
    } else if (resize != 0) {
      setResizeDlg(true)
    }
  }, [!!resize])

  const isAddedToHome = useSelector(
    (state) => state.persistedParams.isAddedToHome
  );

  // if (window.screen.width > 540 && window.screen.height > 720)
  //   return <GoToWebPage />;

  if (!isAddedToHome) return <AddToHome />;

  if (resizeDlg) return <Dialog bodyTxt={'لطفا گوشی تلفن خود را عمودی نگه دارید'} DialogIcon={RotatePhone} />

  return (
    <HashRouter>
      <HeaderMain />
      <Suspense fallback={<div></div>}>
        <Switch>
          {routes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                name={route.name}
                // component={route.component}
                render={(props) => <route.component {...props} />}
              />
            );
          })}
          {!isLogin && <Redirect to="login" />}
          {isLogin && <Redirect form="/" to="/home" />}
        </Switch>
      </Suspense>
    </HashRouter>
  );
};

export default App;
